export const capitalise = (name) =>{
    const arr = name?.split(" ")
    let str = ""
    arr?.forEach(ele =>{

      if (ele.length === 1) {
        str += ele.toUpperCase() + " "; 
      } else {
        for(let i = 0 ; i < ele.length ; i++){
          if(i == 0){
         str += ele[i] 
       }
       if(i == ele.length - 1){
         str += ele[i].toLowerCase() + " "
       }
       if(i > 0 && i < ele.length - 1 ){
         str += ele[i].toLowerCase()
       }
     }
    }
})
    return str.trim()
}